// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 875 ? "helloworld" : chunkId) + "." + {"343":"ac20b56c","875":"e93bc5f8"}[chunkId] + ".css";
};